import { TableHead, styled } from '@mui/material';

export const BoldTableHead = styled(TableHead)(({ theme }) => ({
  '& th': {
    fontWeight: theme.typography.fontWeightBold
  }
}));

export const BoldThemedTableHead = styled(TableHead, { shouldForwardProp: prop => prop !== 'color' })(({ theme, color = 'primary' }) => ({
  '& th': {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette[color]?.main
  }
}));
